import { NotificationStore, NotificationLevel } from "../../stores/NotificationStore";
import * as _html2canvas from "html2canvas";
const html2canvas: any = _html2canvas; // костыль без которого не работает


export function makeMobileViewScreenshot(notificationStore: NotificationStore): void {
    const modal = document.querySelector(".modal") as HTMLElement | null;
    if (!modal) return;

    const modalHeader = modal.querySelector(".modal-header") as HTMLElement | null;
    const modalBody = modal.querySelector(".modal-body") as HTMLElement | null;
    if (!modalBody) return;

    const table = modalBody.querySelector(".mobile-table") as HTMLTableElement | null;
    if (!table) return;

    const headers = modalBody.querySelectorAll(".row") as NodeListOf<HTMLElement>;
    const alert = modalBody.querySelector(".alert") as HTMLElement | null;

    const rows = table.querySelectorAll("tbody tr") as NodeListOf<HTMLTableRowElement>;
    const items: Array<{
        position: HTMLTableRowElement;
        description: HTMLTableRowElement | null;
        comment: HTMLTableRowElement | null;
    }> = [];

    let currentItem: {
        position: HTMLTableRowElement;
        description: HTMLTableRowElement | null;
        comment: HTMLTableRowElement | null;
    } | null = null;

    rows.forEach(row => {
        if (row.cells.length === 6 && row.cells[0].textContent?.trim().match(/^\d+\./)) {
            currentItem = { position: row, description: null, comment: null };
            items.push(currentItem);
        } else if (row.cells.length === 1 && !row.querySelector("small")) {
            if (currentItem) currentItem.description = row;
        } else if (row.cells.length === 1 && row.querySelector("small")) {
            if (currentItem) currentItem.comment = row;
        }
    });

    const itemCount = items.length;
    const tempContainer = document.createElement("div");

    let containerWidth = "540px";
    if (itemCount > 23) {
        containerWidth = "1580px";
    } else if (itemCount > 11) {
        containerWidth = "1060px";
    }

    tempContainer.style.cssText = `
        position: absolute;
        top: -9999px;
        left: -9999px;
        background: white;
        padding: 0 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: ${containerWidth};
    `;

    if (modalHeader) {
        const clonedHeader = modalHeader.cloneNode(true) as HTMLElement;
        const screenshotButton = clonedHeader.querySelector("button.btn-primary");
        if (screenshotButton) screenshotButton.remove();
        tempContainer.appendChild(clonedHeader);
    }

    headers.forEach(row => {
        tempContainer.appendChild(row.cloneNode(true));
    });

    const tableContainer = document.createElement("div");
    tableContainer.style.cssText = `
        display: flex;
        flex-direction: row;
        gap: 20px;
        flex-wrap: nowrap;
    `;

    const clonedTable = table.cloneNode(true) as HTMLTableElement;
    clonedTable.style.width = "500px";

    if (itemCount <= 11) {
        tableContainer.appendChild(clonedTable);
    } else {
        const parts = itemCount > 23 ? 3 : 2;
        const chunkSize = Math.ceil(itemCount / parts);

        for (let col = 0; col < parts; col++) {
            const colTable = clonedTable.cloneNode(true) as HTMLTableElement;
            const colTbody = colTable.querySelector("tbody") as HTMLTableSectionElement | null;
            if (!colTbody) continue;

            colTbody.innerHTML = '';
            for (let i = col * chunkSize; i < (col + 1) * chunkSize && i < itemCount; i++) {
                const item = items[i];
                colTbody.appendChild(item.position.cloneNode(true));
                if (item.description) colTbody.appendChild(item.description.cloneNode(true));
                if (item.comment) colTbody.appendChild(item.comment.cloneNode(true));
            }

            tableContainer.appendChild(colTable);
        }
    }

    tempContainer.appendChild(tableContainer);

    if (alert) {
        const clonedAlert = alert.cloneNode(true) as HTMLElement;
        clonedAlert.style.fontSize = "12px";
        tempContainer.appendChild(clonedAlert);
    }

    document.body.appendChild(tempContainer);

    html2canvas(tempContainer, {
        scale: 2,
        useCORS: true,
        logging: false,
        allowTaint: true
    }).then(canvas => {
        document.body.removeChild(tempContainer);
        const now = new Date();
        const formattedDate = now.toISOString().slice(0, 10);
        const time = now.toTimeString().slice(0, 8).replace(/:/g, "-");
        const fileName = `КП_${formattedDate}_${time}.png`;

        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }).catch(() => {
        document.body.removeChild(tempContainer);
    });
}